<template>
  <el-row>
    <el-col :span="24">
      <el-select v-model="company"
                 :placeholder="$t('user.selectD', { msg: 'user.selectD' })"
                 style="float: left;margin-bottom: 10px;">
        <el-option v-for="item in allusercompany"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-button v-if="isSuperUser" type="primary" size="mini" @click="newUserDialogVisible = true" style="float:right; height: 28px">{{ $t('user.new', { msg: 'user.new' }) }}</el-button>
    </el-col>
  </el-row>
  <el-table v-loading="loading"
           border
           stripe
           highlight-current-row
            :data="tableData.filter(function(item, index, arr) {
        if(item.usercompany == undefined || item.usercompany.length < 1)
          return false
        else
          return item.usercompany.find(item => item.companyID === company) != undefined;})"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
    <!-- <el-table-column type="selection" width="55">
    </el-table-column> -->
    <el-table-column prop="id" :label="$t('user.id', { msg: 'user.id' })" width="80" sortable>
    </el-table-column>
    <el-table-column prop="username" :label="$t('user.username', { msg: 'user.username' })" width="100" >
    </el-table-column>
    <el-table-column prop="email" :label="$t('user.email', { msg: 'user.email' })" width="200">
    </el-table-column>
    <el-table-column prop="name" :label="$t('user.realname', { msg: 'user.realame' })" width="110">
    </el-table-column>
    <el-table-column prop="roleID" :label="$t('user.role', { msg: 'user.role' })" width="95">
      <template #default="scope">
        <span v-for="item in allrole.filter(function(item, index, arr) {
        if(scope.row.usercompany == undefined || scope.row.usercompany.length < 1)
          return false
        else
          return scope.row.usercompany.find(companyid => companyid.roleID === item.value && companyid.companyID === company) != undefined})"
        :key="item.value">
        {{item.label}}
        </span>
      </template>
    </el-table-column>
    <el-table-column prop="companyID" :label="$t('user.company', { msg: 'user.company' })" width="auto">
      <template #default="scope">
        <el-tag v-for="item in allusercompany.filter(function(item, index, arr) {
          if(scope.row.usercompany == undefined || scope.row.usercompany.length < 1)
            return false
          else
            return scope.row.usercompany.find(companyid => companyid.companyID == item.value) != undefined})"
                :key="item.value"
                effect="dark"
                :value="item.label"
                style="border-color: white;border-radius: 20px">
          {{item.label}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column :label="$t('user.opr', { msg: 'user.opr' })" width="260">
      <template #default="scope">
        <div class="button-container">
        <el-button
            v-if="scope.row.usercompany[0].roleID !== 0 || this.isSuperUser"
            :disabled="scope.row.usercompany[0].roleID === 0"
            type="success"
            size="mini"
            @click="handleAuth(scope.$index, scope.row)">{{ $t('user.auth', { msg: 'user.auth' }) }}</el-button>
        <el-button
            v-if="scope.row.usercompany[0].roleID !== 0 || this.isSuperUser"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">{{ $t('user.update', { msg: 'user.update' }) }}</el-button>
        <el-button
            v-if="scope.row.usercompany[0].roleID !== 0 || this.isSuperUser"
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">{{ $t('user.banUser', { msg: 'user.banUser' }) }}</el-button>
      </div>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog
      :title="$t('user.new', { msg: 'user.new' })"
      v-model="newUserDialogVisible"
      width="70%"
      :before-close="newUserDialogClose">
    <el-form :model="newUserForm" :rules="rules" ref="newUserForm" style="text-align: center;" label-width="95px" class="demo-ruleForm">
      <el-form-item :label="$t('user.usernameLogin', { msg: 'user.usernameLogin' })" prop="username">
        <el-input v-model="newUserForm.username" :placeholder="$t('user.usernameD', { msg: 'user.usernameD' })" :clearable="true" style="width: 300px;float: left"></el-input>
      </el-form-item>

      <el-form-item :label="$t('user.password', { msg: 'user.password' })" prop="passwordPlainText">
        <el-input v-model="newUserForm.passwordPlainText" :placeholder="$t('user.passwordD', { msg: 'user.passwordD' })" style="width: 300px;float: left" show-password></el-input>
      </el-form-item>

      <el-form-item :label="$t('user.realname', { msg: 'user.realname' })" prop="name">
        <el-input  v-model="newUserForm.name" :placeholder="$t('user.realnameD', { msg: 'user.realnameD' })" style="width: 300px;float: left"></el-input>
      </el-form-item>

      <el-form-item :label="$t('user.email', { msg: 'user.email' })" prop="email">
        <el-input v-model="newUserForm.email" :placeholder="$t('user.emailD', { msg: 'user.emailD' })" style="width: 300px;float: left"></el-input>
      </el-form-item>
      <el-row>
        <el-rol :span="12">
      <el-form-item
          v-for="(item, index) in newUserForm.usercompany"
          :label="$t('user.company', { msg: 'user.company' }) + ' ' + index"
          :key="item.companyID"
          :prop="'usercompany[' + index + '].companyID'"
          :rules="{
      required: true, message: this.$t('user.companyNotNull', { msg: 'user.companyNotNull' }), trigger: 'blur'
    }"
      >
            <el-select v-model="item.companyID" :placeholder="$t('user.companyD', { msg: 'user.companyD' })" style="float: left">
              <el-option v-for="item in allusercompany"
                         :disabled="newUserForm.usercompany.filter(item1 => item1.companyID === item.value).length>=1"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
      </el-rol>
      <el-rol :span="12">
        <el-form-item
        v-for="(item, index) in newUserForm.usercompany"
        :key="item.roleID"
        :prop="'usercompany[' + index + '].roleID'"
        :label="$t('user.roleM', { msg: 'user.roleM' })"
        :rules="{ required: true, message: this.$t('user.selectRole', { msg: 'user.selectRole' }), trigger: 'blur'}">
            <!-- <span style="float: left">{{ $t('user.roleM', { msg: 'user.roleM' }) }}</span> -->
            <el-select v-model="item.roleID" :placeholder="$t('user.roleD', { msg: 'user.roleD' })" style="float: left; width: 250px">
              <el-option v-for="item in addrole"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         :disabled="item.disabled"
                         >
              </el-option>
            </el-select>
            <el-button style="margin-left: 10px;" v-if="index>0 || newUserForm.usercompany.length > 1" @click.prevent="removeNewUserCompany(item)">{{ $t('issue.table.delete', { msg: 'issue.table.delete' }) }}</el-button>
      </el-form-item>
    </el-rol>
      </el-row>
    </el-form>

    <template #footer>
    <span class="dialog-footer">
      <el-button @click="addNewUserCompany">{{ $t('user.newCompany', { msg: 'user.newCompany' })  }}</el-button>
      <el-button type="primary" @click="submitForm('newUserForm')">{{ $t('user.createNow', { msg: 'user.createNow' })  }}</el-button>
      <el-button @click="resetForm('newUserForm')">{{ $t('user.reset', { msg: 'user.reset' })  }}</el-button>
    </span>
    </template>
  </el-dialog>
  <el-dialog
      :title="$t('user.updateUser', { msg: 'user.updateUser' })  + changeUserForm.username"
      v-model="changeUserDialogVisible"
      width="70%"
      :before-close="changeUserDialogClose">
    <el-form :model="changeUserForm" :rules="changeUserrules" ref="changeUserForm" label-width="150px" class="demo-ruleForm">

      <el-form-item :label="$t('user.realname', { msg: 'user.realname' }) " prop="name">
        <el-input  v-model="changeUserForm.name" :placeholder="$t('user.realnameD', { msg: 'user.realnameD' }) " style="width: 200px;float: left"></el-input>
      </el-form-item>

      <el-form-item :label="$t('user.password', { msg: 'user.password' }) " prop="password">
        <el-input  v-model="changeUserForm.passwordPlainText" :placeholder="$t('user.passwordD', { msg: 'user.passwordD' }) " style="width: 200px;float: left" show-password></el-input>
      </el-form-item>

      <el-form-item :label="$t('user.email', { msg: 'user.email' }) " prop="email">
        <el-input  v-model="changeUserForm.email" :placeholder="$t('user.emailD', { msg: 'user.emailD' }) " style="width: 300px;float: left"></el-input>
      </el-form-item>

      <el-form-item
          v-for="(item, index) in changeUserForm.usercompany"
          :label="$t('user.company', { msg: 'user.company' })  + ' ' + + index"
          :key="item.companyID"
          :prop="'usercompany[' + index + '].companyID'"
          :rules="{
      required: true, message: this.$t('user.companyNotNull', { msg: 'user.companyNotNull' }), trigger: 'blur'
    }"
      >
        <el-row :gutter="10">
          <el-col :span="9">
            <el-select v-model="item.companyID" :placeholder="$t('user.companyD', { msg: 'user.companyD' }) " style="float: left">
              <el-option v-for="item in allusercompany"
                         :disabled="changeUserForm.usercompany.filter(item1 => item1.companyID === item.value).length>=1"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="15">
            <span style="float: left ">{{ $t('user.roleM', { msg: 'user.roleM' })  }}</span>
            <el-select v-model="item.roleID" :placeholder="$t('user.roleD', { msg: 'user.roleD' }) " style="float: left; width: 200px">
              <el-option v-for="item in addrole"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         :disabled="item.disabled">
              </el-option>
            </el-select>
            <el-button type='danger' v-if="index>0 || changeUserForm.usercompany.length > 1" @click.prevent="removeChangeUserCompany(item)">{{ $t('user.delete', { msg: 'user.delete' })  }}</el-button>
          </el-col>
        </el-row>
      </el-form-item>

    </el-form>

    <template #footer>
    <span class="dialog-footer">
      <el-button @click="addChangeUserCompany">{{ $t('user.newCompany', { msg: 'user.newCompany' })  }}</el-button>
      <el-button type="primary" @click="submitUserForm('changeUserForm')">{{ $t('user.update', { msg: 'user.update' })  }}</el-button>
      <el-button @click="changeUserDialogVisible = false;">{{ $t('user.cancel', { msg: 'user.cancel' })  }}</el-button>
    </span>
    </template>
  </el-dialog>

  <el-dialog v-model="userAuthDialogVisible" 
             :title="$t('auth.authIssueTypeTitle', { msg: 'auth.authIssueTypeTitle' })"
             width="30%"
             center>
    <el-form ref="userAuthFormRef" :model="userAuthForm" label-width="16%" :rules="userAuthRules">
      <el-form-item :label="$t('auth.authIssueTypeUsername', { msg: 'auth.authIssueTypeUsername' })" prop="user">
        <el-input v-model="userAuthForm.user" readonly></el-input>
      </el-form-item>
      <el-form-item :label="$t('auth.authIssueTypeCompany', { msg: 'auth.authIssueTypeCompany' })" prop="company">
        <el-select 
        v-model="userAuthForm.company"
                   style="width: 100%"
                   @change="handleChangeCompany()"
                   >
          <el-option 
          v-for="item in userAuthCompany" 
                          :key="item.companyName"
                          :value="item.companyId"
                          :label="item.companyName"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('auth.authIssueType', { msg: 'auth.authIssueType' })" prop="auth">
        <el-select v-model="userAuthForm.auth" 
                   style="width: 100%"
                   multiple
                   clearable
                   :max-collapse-tags="1"
                   >
          <el-option v-for="item in userAuthType"
                           :key="item.typeName"
                           :value="item.issueTypeId"
                           :label="item.typeName"></el-option>
        </el-select>
    </el-form-item>
    </el-form>
    <template #footer>
    <span class="dialog-footer">
      <el-button @click="saveAuth('userAuthFormRef')" type="primary">{{ $t('user.save', { msg: 'user.save' })  }}</el-button>
      <el-button @click="handelAuthClose()" type="danger">{{ $t('user.cancel', { msg: 'user.cancel' })  }}</el-button>
    </span>
    </template>
  </el-dialog>
</template>

<script>
import {
  deleteUser,
  banUser,
  getallrole,
  getuserbycompany,
  getusercompany,
  insertUser, updateUser
} from "../../axios";
import { baseUrl_New } from '../../axios/urlconfig';
import { getRequest, postRequest } from '../../axios/axios';

export default {
  name: "usershow",
  props:['userid','username','realname','role','companyID','usercompany'],
  data() {
    return{
      allrole: [],
      allusercompany: [{
        label: 'test',
        value:1
      }],
      tableData :[{
        id:'1',
        username:'jack',
        password:'123456',
        name:'ssh',
        email: ''
      },{
          id:'2',
          username:'sop',
          password:'123456',
          name:'mmp'
      },{
          id:'3',
          username:'nice',
          password:'abcdef',
          name:'xy'
      }],
      newUserForm: {
        username: '',
        passwordPlainText: '',
        name: '',
        usercompany: [],
        email: '',
      },
      changeUserForm: {
        username: '',
        passwordPlainText: '',
        name: '',
        roleID: '',
        usercompany: [],
        email: '',
      },
      isSuperUser: false,
      userAuthForm:{
        userId: 0,
        user: '',
        company: '',
        companyId: 0,
        auth: [],
      },
      userAuthCompany: [],
      userAuthType: [],
      rules: {
        username: [
          { required: true, message: this.$t('user.usernameD', { msg: 'user.usernameD' }), trigger: 'blur' },
          { min: 1, max: 15, message: this.$t('user.lengthD115', { msg: 'user.lengthD115' }), trigger: 'blur' }
        ],
        passwordPlainText: [
          {required: true, message: this.$t('user.passwordD', { msg: 'user.passwordD' }) ,trigger: 'blur'},
          {min: 6, max: 255, message: this.$t('user.lengthD615', { msg: 'user.lengthD615' }), trigger: 'blur'}
        ],
        email:[
          {required: false, message: this.$t('user.emailD', { msg: 'user.emailD' }) ,trigger: 'blur'},
          {pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/ ,message: this.$t('user.emailP', { msg: 'user.emailP' }), trigger: 'blur'}
        ],
        name: [
          { required: true, message: this.$t('user.realnameD', { msg: 'user.realnameD' }), trigger: 'change' },
          { min: 1, max: 50, message: this.$t('user.lengthD615', { msg: 'user.lengthD150' }), trigger: 'blur' }
        ]
      },
      changeUserrules: {
        name: [
          { required: true, message: this.$t('user.realnameD', { msg: 'user.realnameD' }), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('user.lengthD615', { msg: 'user.lengthD150' }), trigger: 'blur'}
        ],
        password: [
          {required: true, message: this.$t('user.passwordD', { msg: 'user.passwordD' }) ,trigger: 'blur'},
          {min: 6, max: 255, message: this.$t('user.lengthD615', { msg: 'user.lengthD615' }), trigger: 'blur'}
        ],
        email:[
          {required: false, message: this.$t('user.emailD', { msg: 'user.emailD' }) ,trigger: 'blur'},
          {pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/ ,message: this.$t('user.emialD', { msg: 'user.emailD' }), trigger: 'blur'}
        ],
      },
      userAuthRules: {
        user:[{
          required: true, message: '请输入', trigger: 'blur'
        }],
        company: [{
          required: true, message: '请输入', trigger: 'blur'
        }],
        auth:[{
          required: false, message: '请输入', trigger: 'blur'
        }],
      },
      company: '',
      adminCompanyID:[],
      adminRoleID: [],
      newUserDialogVisible: false,
      changeUserDialogVisible: false,
      loading: true,
      userAuthDialogVisible: false,
      addrole:[
        {value:0,
          label: '超级管理员',
          disabled: true
        },
        {value:1,
        label:'工程师'},
        {value:2,
        label:'客服'},
        {value:3,
        label:'客户'},
        {value:4,
        label:'普通管理员'},
        {value:5,
        label:'专家'},
      ],
      nowRole: "",
    }
  },
  async created() {
    await this.getallrole();
    await this.setAdmin();
    await this.getUserCompany();
    await this.updatetable();
    await this.addNewUserCompany();
    this.isSuperAdmin();
  },
  methods:{
    setAdmin(){
      for(let i=0;i<this.usercompany.length;i++) {
        for(let j=0;j<this.adminRoleID.length;j++){
        if(this.usercompany[i].roleID === this.adminRoleID[j]){
          this.adminCompanyID.push(this.usercompany[i].companyID);
        }
      }
      }
    },
    isSuperAdmin(){
      if(sessionStorage.getItem('role').includes('超级管理员')){
        this.isSuperUser = true;
      }else {
        this.isSuperUser = false;
      } 
    },
    addNewUserCompany(){  //添加用户的公司
      this.newUserForm.usercompany.push({
        companyID: '',
        roleID: null
      });
    },
    removeNewUserCompany(item) {
      let index = this.newUserForm.usercompany.indexOf(item)
      if (index !== -1) {
        this.newUserForm.usercompany.splice(index, 1)
      }
    },
    addChangeUserCompany(){  //添加用户的公司
      this.changeUserForm.usercompany.push({
        companyID: '',
        roleID: null
      });
    },
    removeChangeUserCompany(item) {
      let index = this.changeUserForm.usercompany.indexOf(item)
      if (index !== -1) {
        this.changeUserForm.usercompany.splice(index, 1)
      }
    },
    getUserCompany() { //获得用户的公司信息
      getusercompany({
        companyID: this.adminCompanyID.toString()
      }).then(res => {
        //console.log(res);
        this.allusercompany.splice(0, this.allusercompany.length);
        for (let i = 0; i < res.count; i++) {
          this.allusercompany.push({
            text: res.data[i].companyname,
            label: res.data[i].companyname,
            value: res.data[i].companyID
          });
        }
        this.allusercompany.sort(function (a, b) {
          return a.label > b.label ? 1 : -1;
        }); //将公司根据公司名排序
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
    },
    updatetable(){
      this.loading = true;
      getuserbycompany({
        companyID: this.adminCompanyID.toString()
      }).then(res=>{
        console.log(res);
        this.tableData = res.data;
        this.loading = false;
      }).catch(err=>{
        console.log(err);
      });
    },
    async getallrole() {  //得到所有角色信息
      await getallrole().then(res => {
        //console.log(res);
        this.allrole = res.data;
        
        //管理员权限包括 0 超级管理员 4 外部管理员
        if(this.allrole.find(item => item.label.includes('管理员')).value != undefined){
          this.adminRoleID.push(0); 
          this.adminRoleID.push(4);
        }

        //this.adminRoleID.push(this.allrole.find(item => item.label.includes('管理员')).value);
      }).catch(err => {
        console.log(err);
      })
    },
    submitForm(formName) {  //提交表单
      this.$refs[formName].validate((valid) => { 
        if (valid) {
          insertUser(this.newUserForm).then(res =>{

            if(res === '插入成功'){
              this.$message.success(this.$t('user.insertS', { msg: 'user.insertS' }));
              this.newUserForm.name = '';
              this.newUserForm.username = '';
              this.newUserForm.usercompany = [];
              this.newUserForm.email = '';
              this.addNewUserCompany();
              this.newUserDialogClose();
              this.updatetable();
            }else if(res === '用户名已存在'){
              this.$message.error(this.$t('user.inserterrUN', { msg: 'user.inserterrUN' }));
              this.newUserForm.name = '';
              this.newUserForm.username = '';
              this.newUserForm.usercompany = [];
              this.newUserForm.email = '';
              this.addNewUserCompany();
              this.newUserDialogClose();
              this.updatetable();
            }else if(res === '姓名已存在'){
              this.$message.error(this.$t('user.inserterrN', { msg: 'user.inserterrN' }));
              this.newUserForm.name = '';
              this.newUserForm.username = '';
              this.newUserForm.usercompany = [];
              this.newUserForm.email = '';
              this.addNewUserCompany();
              this.newUserDialogClose();
              this.updatetable();
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitUserForm(formName){ //修改用户表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateUser({
            user:this.changeUserForm,
            usercompany: this.tableData.find(item => item.id === this.changeUserForm.id).usercompany
          }).then(res =>{
            if(res === '修改成功'){
              this.$message.success(this.$t('user.updateS', { msg: 'user.updateS' }));
              this.changeUserForm.name = '';
              this.changeUserForm.roleID = '';
              this.changeUserForm.username = '';
              this.changeUserForm.companyID = [];
              this.changeUserForm.email = '';
              this.changeUserDialogClose();
              this.updatetable();
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {  //重置表单
      this.$refs[formName].resetFields();
    },
    handleEdit(index, row) { //修改问题
      this.changeUserForm = JSON.parse(JSON.stringify(row));
      this.changeUserDialogVisible = true;
    },
    handleDelete(index, row) { //删除按钮
      this.openConfirm(row);
    },
    handleAuth(index, row){
      this.userAuthForm.user = '';
      this.userAuthForm.company = '';
      this.userAuthForm.userId = 0;
      console.log(this.userAuthForm.auth);
      this.userAuthForm.auth = [];
      console.log(this.userAuthForm.auth);
      this.userAuthCompany = [];
      this.userAuthType = [];
      this.userAuthForm.user = row.name;
      this.userAuthForm.userId = row.id;
      this.userAuthDialogVisible = true;
      getRequest(baseUrl_New + '/queryusercompany/' + this.userAuthForm.userId)
      .then(res => {
        // console.log(res);
        this.userAuthCompany = res;
      }).catch(err => {
        console.log(err);
      })
    },
    handelAuthClose(){
      this.userAuthDialogVisible = false;
    },
    changeUserDialogClose(){
      this.changeUserDialogVisible = false;
    },
    openConfirm(row) {
      this.$confirm(this.$t('user.info', { msg: 'user.info' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
        confirmButtonText: this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
        cancelButtonText: this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        banUser({
          userid: row.id,
          username: sessionStorage.getItem('username'),
        }).then(res=>{
          if(res === '删除成功'){
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
            this.updatetable();
          }else if(res === 'admin不可被删除'){
            this.$message.error(this.$t('user.deleteAdmin', { msg: 'user.deleteAdmin' }));
          }else if(res === '不可删除自己'){
            this.$message.error(this.$t('user.deleteSelf', { msg: 'user.deleteSelf' }));
          }else{
            this.$message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }))
          }
        }).catch(err=>{
          console.log(err);
          this.$message.error(err);
        });
      })
    },
    newUserDialogClose(){ //关闭新增用户对话框
      this.newUserDialogVisible = false;
    },
    handleChangeCompany(){
      this.userAuthType = [];
      getRequest(baseUrl_New + '/auth/getTypeId?userId=' + this.userAuthForm.userId + '&companyId=' + this.userAuthForm.company)
      .then(res => {
        this.userAuthForm.auth = res.data.list;
        getRequest(baseUrl_New + '/querytype/' + this.userAuthForm.company)
         .then(res => {
          for(let i = 0;i < res.length; i++){
            this.userAuthType.push(res[i]);
          }
      })
      }).catch(err => {
        console.log(err);
      })
    },
    saveAuth(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            'companyId': this.userAuthForm.company,
            'userId': this.userAuthForm.userId,
            'typeIdList': this.userAuthForm.auth
          }
          postRequest(baseUrl_New + '/auth/issuetype',data,{
          })
          .then(res => {
            if(res.code === 200){
              this.$message.success('新增成功');
              this.handelAuthClose();
            }else{
              this.$message.error('新增失败');
            }
            console.log(res);
          }).catch(err => {
            console.log(err);
          })
        }else{
          console.log("error");
        }
      });
    },
  }
}
</script>

<style scoped>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px; /* 按钮之间的间距，可根据需要调整 */
}
</style>
